import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyKeringMode({ brand, today, Copy }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  // Stable, namespaced gradient ID to avoid collisions across modes and rerenders
  const gradId = React.useMemo(() => {
    try {
      const url = typeof window !== "undefined" ? new URL(window.location.href) : null;
      const param = url
        ? url.searchParams.get("id") || url.searchParams.get("uid") || url.searchParams.get("modeId") || url.searchParams.get("mode_id")
        : null;
      return param ? `vasarelyKering_grad_${param}` : `vasarelyKering_grad_${Math.random().toString(36).slice(2, 8)}`;
    } catch {
      return `vasarelyKering_grad_${Math.random().toString(36).slice(2, 8)}`;
    }
  }, []);

  // Flattened organic grid for more predictable vdom
  const organicCircles: React.ReactNode[] = [];
  for (let i = 0; i < 12; i++) {
    for (let j = 0; j < 16; j++) {
      const x = -300 + i * 50;
      const y = -400 + j * 50;
      const isOrganic = (i + j) % 3 === 0;
      organicCircles.push(
        <circle
          key={`organic-${i}-${j}`}
          cx={x}
          cy={y}
          r={isOrganic ? 12 : 8}
          fill={isOrganic ? "#66BB6A" : "none"}
          stroke="#FFFFFF"
          strokeWidth={1}
          opacity={isOrganic ? 0.3 : 0.15}
        />
      );
    }
  }

  const concentric: React.ReactNode[] = [];
  for (let r = 0; r < 16; r++) {
    concentric.push(
      <circle
        key={`circular-${r}`}
        cx={0}
        cy={0}
        r={(r + 1) * 25}
        fill="none"
        stroke="#FFFFFF"
        strokeWidth={r % 4 === 0 ? 2.5 : 1.5}
        opacity={Math.max(0, 0.3 - r * 0.014)}
      />
    );
  }

  return (
    <g>
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#2E7D32", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#66BB6A", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#D4AF37", stopOpacity: 0.3 }} />
        </linearGradient>
      </defs>

      <rect width={width} height={height} fill={`url(#${gradId})`} />

      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {organicCircles}
        {concentric}
        <circle cx={0} cy={0} r={55} fill="none" stroke="#66BB6A" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={38} fill="#2E7D32" opacity={0.4} />
      </g>

      <g className="mode-copy" transform="translate(48, 840)" fill="#FFFFFF" fontFamily="monospace">
        <text x={0} y={0} fontSize={18} fontWeight="bold">
          {Copy?.title}
        </text>
        <text x={0} y={22} fontSize={14}>
          {Copy?.subtitle}
        </text>
        <text x={0} y={44} fontSize={12} opacity={0.85}>
          {Copy?.date}
        </text>
      </g>
    </g>
  );
}
